import { visibleItemCount } from "../helpers/gift-wrap";

class CartCount extends HTMLElement {
  connectedCallback() {
    this.onUpdateCart = (e) => {
      const cart = e.detail.cart;
      if (!Array.isArray(cart?.items)) return;

      // Monogram lines count as part of their item, as in section.header.liquid
      const monogramProductIds = (this.dataset.monogramProductIds || "")
        .split(",")
        .filter(Boolean)
        .map(Number);
      const items = cart.items.filter(
        (item) =>
          !(
            item.properties?._uuid &&
            monogramProductIds.includes(item.product_id)
          ),
      );

      this.setCount(visibleItemCount({ ...cart, items }));
    };

    document.addEventListener("updateCart", this.onUpdateCart);
  }

  disconnectedCallback() {
    document.removeEventListener("updateCart", this.onUpdateCart);
  }

  setCount(count) {
    const label =
      count === 1
        ? this.dataset.one
        : (this.dataset.other || "").replace("[count]", count);

    this.innerHTML = `
      <span aria-hidden="true">${count > 0 ? count : 0}</span>
      <span class="visually-hidden">${label}</span>`;

    // The bubble is a badge over the bag icon, so an empty bag shows no bubble at all.
    this.hidden = count === 0;
  }
}

if (!customElements.get("cart-count")) {
  customElements.define("cart-count", CartCount);
}
